import { useQuery } from 'react-query'
import { getDefaultPlans } from 'services/cm-api/get-default-plans'

export function useDefaultPlans() {
  return useQuery(['getDefaultPlans'], () => getDefaultPlans())
}
